if (!customElements.get("m-recently-viewed")) {
  class MRecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.handleResponsiveChange = this.handleResponsiveChange.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = parseInt(this.dataset.productsPerRow, 10) || 4;
      this.mobileItems = parseFloat(this.dataset.mobileItems) || 1.2;
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      this.productsToshow = parseInt(this.dataset.productsToShow, 10);

      this.init();
    }

    disconnectedCallback() {
      document.removeEventListener("matchMobile", this.handleResponsiveChange);
      document.removeEventListener("unmatchMobile", this.handleResponsiveChange);
      clearTimeout(this.sliderInitTimeout);
      if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(false, true);
    }

    handleResponsiveChange() {
      this.initByScreenSize();
    }

    init() {
      fetch(this.dataset.url + this.getQueryString())
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("m-recently-viewed");
          if (!recommendations) return;
          this.products = recommendations.querySelectorAll(".m-product-card").length;
          if (this.products > 0) {
            this.classList.remove("m:hidden");
          }
          if (recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initByScreenSize();
            document.addEventListener("matchMobile", this.handleResponsiveChange);
            document.addEventListener("unmatchMobile", this.handleResponsiveChange);

            MinimogTheme.CompareProduct?.setCompareButtonsState();
            MinimogTheme.Wishlist?.setWishlistButtonsState();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const controlsContainers = this.querySelectorAll(
        ".m-featured-collection__product-nav-controls, .m-featured-collection__product-controls"
      );

      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        controlsContainers.forEach((controls) => controls.classList.add("m:hidden"));
        slideContainer && slideContainer.classList.remove("swiper-container");
        if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(false, true);
        this.swiper = null;
      } else {
        controlsContainers.forEach((controls) => controls.classList.remove("m:hidden"));
        clearTimeout(this.sliderInitTimeout);
        this.sliderInitTimeout = setTimeout(() => this.initSlider());
      }
    }

    toggleControls(swiper) {
      this.querySelectorAll(
        ".m-featured-collection__product-nav-controls, .m-featured-collection__product-controls"
      ).forEach((controls) => {
        controls.classList.toggle("m-featured-collection__controls--hidden", swiper.isLocked);
      });
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const navigationControls =
        this.querySelector(".m-featured-collection__product-nav-controls") ||
        this.querySelector(".m-featured-collection__product-controls");
      const paginationControls = this.querySelector(".m-featured-collection__product-controls");
      const prevButton = navigationControls && navigationControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = navigationControls && navigationControls.querySelector(".m-slider-controls__button-next");
      const pagination = paginationControls && paginationControls.querySelector(".swiper-pagination");
      if (!slideContainer) return;

      if (slideContainer.swiper && !slideContainer.swiper.destroyed) {
        slideContainer.swiper.update();
        this.toggleControls(slideContainer.swiper);
        return;
      }

      slideContainer.classList.add("swiper-container");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: this.mobileItems,
        spaceBetween: 0,
        watchOverflow: true,
        loop: false,
        pagination: this.showPagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        navigation:
          this.showNavigation && prevButton && nextButton
            ? {
                prevEl: prevButton,
                nextEl: nextButton,
              }
            : false,
        breakpoints: {
          768: {
            slidesPerView: this.items >= 3 ? 3 : this.items,
          },
          1024: {
            slidesPerView: this.items >= 4 ? 4 : this.items,
          },
          1280: {
            slidesPerView: this.items,
          },
        },
        threshold: 2,
        on: {
          init: (swiper) => this.toggleControls(swiper),
          breakpoint: (swiper) => this.toggleControls(swiper),
          resize: (swiper) => this.toggleControls(swiper),
        },
      });

      this.swiper = slideContainer.swiper;
    }

    getQueryString() {
      const cookieName = "minimog-recently-viewed";
      const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
      if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
        items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
      }
      return items
        .map((item) => "id:" + item)
        .slice(0, this.productsToshow)
        .join(" OR ");
    }
  }
  customElements.define("m-recently-viewed", MRecentlyViewed);
}
